import React from 'react';
import getConfig from 'next/config';
import Header, { Breadcrumbs } from '@domain-group/fe-co-header';

import { Breadcrumb, mapHeaderData } from './utils';
import * as styles from './landing-page-header.style';

const { publicRuntimeConfig } = getConfig();

const SearchResultsHeader = ({
  breadcrumbsData,
  isNewLandingPage = false,
}: {
  breadcrumbsData: Breadcrumb[];
  isNewLandingPage?: boolean;
}): JSX.Element => {
  const headerData = mapHeaderData({
    baseUrl: publicRuntimeConfig.BASE_URL,
    breadcrumbsData: isNewLandingPage ? undefined : breadcrumbsData,
  });

  return (
    <div data-theme-name="domain-2022">
      <Header {...headerData} />
      {isNewLandingPage && (
        <div css={styles.breadcrumbBar}>
          <div css={styles.wrapper}>
            <Breadcrumbs
              baseUrl={publicRuntimeConfig.BASE_URL}
              breadcrumbs={breadcrumbsData}
              backButtonLabel="Back"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchResultsHeader;
